import { RouterModule, Routes } from '@angular/router';
import { Graficas1Component } from './graficas1/graficas1.component';
import { ProgressComponent } from './progress/progress.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PagesComponent } from './pages.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { PromesasComponent } from './promesas/promesas.component';
import { RxjsComponent } from './rxjs/rxjs.component';
import { LoginGuardGuard } from '../services/guards/login-guard.guard';


const pagesRoutes:Routes = [
    { 
        path: '',
        component: PagesComponent,
        canActivate: [LoginGuardGuard],
        children: [
           { path: 'dashboard', component: DashboardComponent, data: {titulo:'Dashboard'}},
           { path: 'progress', component: ProgressComponent, data: {titulo:'Progreso'}},
           { path: 'graficas1', component: Graficas1Component, data: {titulo:'Gráficas'}},
           { path: 'promesas', component: PromesasComponent, data: {titulo:'Promesas'}},
           { path: 'rxjs', component: RxjsComponent, data: {titulo:'RxJs'}},
           { path: 'account-settings', component: AccountSettingsComponent, data: {titulo:'Ajustes de la Cuenta'}},
           { path: '', redirectTo: '/dashboard', pathMatch: 'full'},
        ]
       }
];

export const PAGES_ROUTES = RouterModule.forChild(pagesRoutes);